<template>
    <div class="inc_full">
        <div class="listall">
 
            <!--搜尋列-->
            <div class="seachbar">
                <div class="seakeyword">
                    <b-form-input
                        id="keywords"
                        v-model="search.keywords"
                        placeholder="請輸入關鍵字"
                        aria-label="請輸入關鍵字" 
                        v-on:keyup.enter="searchList"
                        maxlength="100"
                        class="inputar"></b-form-input></div>
                <div class="seachbtn">
                    <b-button 
                        class="serbtnbx"
                        @click="searchList">查詢</b-button> 
                </div>
            </div>
            <!--搜尋列結束-->

            <!--整體列表-->
            <div :class="table_Class">
                <!--內容列表查無資料物件-->
                <div :class="list_Class" v-if="list.length==0">
                    <div class="hmnewword">
                        目前尚無相關搜尋資料
                    </div>
                </div>
                <!--內容列表物件-->
                <div v-else 
                    :class="list_Class" v-for="item in list">
                    <a :href="item.url" target="_blank">
                        <div class="hmnewdat">
                            <div class="hmdtag tag_pink">
                                {{ item.codename }}
                            </div>
                            <div class="hmdtag tag_org" v-if="item.tag!=''&&item.tag!=null">
                                {{ item.tag }}
                            </div>
                        </div>
                        <div class="hmnewword" v-html="item.title"></div>
                        <div class="hmdtex" v-html="item.description"></div>
                    </a>
                </div>
            </div>
            <!--頁碼-->
            <!-- TODO 動態取得頁碼-->
            <div class="twpage" v-if="list.length>0">
                <div class="navigation">
                <b-pagination
                    class="pagination light-theme simple-pagination"
                    v-model="pagination.page"
                    :total-rows="pagination.rows"
                    :per-page="pagination.perPage"
                    aria-controls="my-table"
                ></b-pagination>
                </div>
            </div> 
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            //列表樣式
            table_Class:"",
            //文章項目樣式
            list_Class:"",
            //列表資料
            list:[{
                title:"",
                description:"",
                tag: "",
            }],
            search: {},
        };
    },
    props:["sideright", "pagination"],
    mounted(){
        //初始化
        this.init();
    },
    watch:{ 
        "sideright.list"(){
            this.list = this.sideright.list;
        },
        "pagination.page"() {
            this.$emit('sidesearch', this.search);
        },
    },
    methods:{
        //初始化
        init(){
            this.table_Class=this.sideright.table_Class;
            this.list_Class = this.sideright.list_Class;
            this.list = this.sideright.list;

            if(this.$route.query){
                this.search.keywords = decodeURIComponent(this.$route.query.q);

                //透過首頁搜尋
                this.searchList();
            }
        },
        //搜尋條件
        searchList() {
            if(this.search.keywords == "") 
                alert("請輸入關鍵字");
            else {
                this.$emit('sidesearch', this.search);
            }
        },
    }

}
</script>